// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false
};

export const config = {
  issuer: 'https://myappstest.halliburton.com/oauth2/ausk4axfvsdNLJ8rU0h7',
  redirectUri: 'https://qainvoice.halliburton.com/implicit/callback',
  clientId: '0oa10q953d9w4Hx0E0h8',
  scope: 'openid profile email'
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
